import { Injectable } from "@nestjs/common";
import { EntityRepository, getManager, Repository } from "typeorm";
import { PayrollLogs } from "../entity/payroll-log";
import { EmployeeIdReq } from "../dto/employee-id.req";
import appSettings from "apps/services/config";

@Injectable()
@EntityRepository(PayrollLogs)
export class PayslipProcessRepository extends Repository<PayrollLogs> {

    constructor() {
        super();
    }

    async getByEmployeeId(req: EmployeeIdReq): Promise<any[]> {
        try{
            const manager = getManager();
            let query = `SELECT p.id, p.employee_id as employeeId, p.employee_name AS employeeName, p.employee_code AS employeeCode, p.employee_type AS employeeType, p.employee_category AS employeeCategory, p.designation AS designationId,de.designation,d.dept_name AS department, p.payroll_month AS payrollMonth, p.factory_working_days AS factoryWorkingDays, p.attendance, p.basic, p.hra_amount AS hraAmount, p.edu_amount AS eduAmount, p.medical_amount AS medicalAmount, p.spl_amount AS splAmount, p.conveyance_amount AS conveyanceAmount, p.petrol_amount AS petrolAmount, p.shoe_amount AS shoeAmount, p.washing_amount AS washingAmount, p.uniform_amount AS uniformAmount, p.helper_amount AS helperAmount, p.production_amount AS productionAmount, p.ta_amount AS taAmount, p.bonus_amount AS bonusAmount, p.gross, p.incentive_hrs AS incentiveHrs, p.cal_basic AS calBasic, p.cal_hra AS calHra, p.cal_edu AS calEdu, p.cal_medical AS calMedical, p.cal_spl AS calSpl, p.cal_conveyance AS calConveyance, p.cal_petrol AS calPetrol, p.cal_shoe AS calShoe, p.cal_wAShing AS calWAShing, p.cal_uniform AS calUniform, p.cal_helper AS calHelper, p.cal_production AS calProduction, p.cal_ta AS calTa, p.cal_bonus AS calBonus, p.cal_gross AS calGross, p.incentive_amount_per_hr AS incentiveAmountPerHr, p.total_incentive_hrs AS totalIncentiveHr, p.incentive_amount AS incentiveAmount, p.total_earnings AS totalEarnings, p.epf_amount AS epfAmount, p.esic_amount AS esicAmount, p.mess_d AS messAmount, p.others_d AS othersAmount, p.tds, p.professional_tax AS professionalTax, p.total_deductions AS totalDeductions, p.net_salary AS netSalary , ed.bank_name AS bank, ed.bank_account_number AS bankAcNo, ed.ifsc_code AS ifsc , ed.uan_number AS uan, ed.date_of_join AS doj , ed.pan_number AS pan , ed.esi_number AS esi, ed.email_id as emailId FROM `+appSettings.hrms_db+`.payroll_log p LEFT JOIN `+ appSettings.masters_db + `.departments d ON d.dept_id = p.department
            LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id = p.employee_id
            LEFT JOIN `+ appSettings.hrms_db + `.designation de ON p.designation = de.designation_id WHERE p.id > 0`
            if (req.employeeId) {
                query = query + ' and p.employee_id IN (' + req.employeeId + ')' ;
            }if (req.month) {
                query = query + ' and p.payroll_month = ' + req.month ;
            }if (req?.employeeType) {
                query = query + ' and p.employee_type = "'+ req?.employeeType +'"';
            }
            return await manager.query(query)
        }catch(err){
            throw err
        }
    }


    async getEmployeeInfoAgainstYearMonth(req: EmployeeIdReq): Promise<any[]> {
        try{
            const manager = getManager();
            let query = `SELECT p.employee_id as employeeId, p.employee_code as employeeCode ,p.employee_name as employeeName,p.employee_type as employeeType,p.designation as designationId,de.designation,d.dept_name AS department,p.payroll_month as payrollMonth,p.employee_category as employeeCategory,ed.email_id as emailId FROM `+appSettings.hrms_db+`.payroll_log p 
            LEFT JOIN `+ appSettings.masters_db + `.departments d ON d.dept_id = p.department
            LEFT JOIN `+ appSettings.hrms_db + `.designation de ON p.designation = de.designation_id
            Left JOin `+ appSettings.masters_db +` .employee_details ed ON ed.employee_id = p.employee_id
            WHERE p.id > 0`
            if (req.month) {
                query = query + ' and p.payroll_month = ' + req.month ;
            }if (req?.employeeType) {
                query = query + ' and p.employee_type = "' + req?.employeeType +'"';
            }if (req.employeeCategory != undefined) {
                query = query +' and p.employee_category = "'+ req.employeeCategory +'"';
            }
            query = query +'GROUP BY p.employee_id ' ;
            query = query +'ORDER BY p.department ';
            return await manager.query(query)
        }catch(err){
            throw err
        }
        
        
    }

}

